import React from 'react';
import { connect } from 'react-redux';
import { goTo } from "../tools";

const mapState = (state) => {
    return {
        preguntaUno: state.miPerfil.preguntaUno,
        preguntaDos: state.miPerfil.preguntaDos
    };
}

const mapDispatch = (dispatch) => {
    return {}
}

class ContactoDeEmergencia extends React.Component {
    ir = (sRuta) => {
        goTo(sRuta);
    }
    render() {
        return <div className="col-xs-12">
            <div className="card perfil-card pd-b-13p">
                <div className="card-header">
                    <div className="row">
                        <div className="col-xs-6">
                            <i><img src={require("../img/cuenta-icono.svg")} /></i><b>Cuenta</b>
                        </div>
                        <div className="col-xs-6">
                            {this.props.preguntaUno != "" && this.props.preguntaDos != "" &&
                                <div className="text-right card-actions-btn">
                                    <a className="orange-btn" onClick={this.ir.bind(this, "eliminar-cuenta")}>Eliminar</a>
                                </div>
                            }
                            {this.props.preguntaUno == "" && this.props.preguntaDos == "" &&
                                <div className="table-center load-comp">
                                    <img src={require("../img/load_mini.gif")} />
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        Al eliminar tu cuenta permanentemente. No podrás ingresar a la aplicación Soy Cliente GNP, ni a los servicios de Call Center.
                    </div>
                </div>
            </div>
        </div>
    }
}

export default connect(mapState, mapDispatch)(ContactoDeEmergencia);



// WEBPACK FOOTER //
// ./src/miPerfil/cuenta.cmpt.js